import { pathsByView, spadeView } from '@ps/web-spade-embedded-api';
import { ThemeVariantSchema } from '@ps/web-spade-types';
import { z } from 'zod/v4-mini';

const spadeLocale = {
  bg: 'bg',
  cs: 'cs',
  da: 'da',
  de: 'de',
  en: 'en',
  el: 'el',
  es: 'es',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'es-419': 'es-419',
  et: 'et',
  fr: 'fr',
  hu: 'hu',
  it: 'it',
  ja: 'ja',
  kl: 'kl',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'pt-BR': 'pt-BR',
  ro: 'ro',
  ru: 'ru',
  sv: 'sv',
  uk: 'uk'
} as const;

export const spadeBrand = {
  PokerStars: 'pokerstars',
  Sisal: 'sisal'
} as const;

export const InitConfig = z.object({ locale: z.enum(spadeLocale) });

// Base fields shared across all view configs
export const BaseLoadFields = {
  element: z.string(),
  themeVariant: z.optional(ThemeVariantSchema)
} as const;

export const LoadConfig = z.discriminatedUnion('view', [
  z.object({
    ...BaseLoadFields,
    view: z.literal(spadeView.CashGames),
    path: z.optional(z.enum(pathsByView[spadeView.CashGames]))
  }),
  z.object({
    ...BaseLoadFields,
    view: z.literal(spadeView.PokerTable),
    path: z.optional(z.enum(pathsByView[spadeView.PokerTable]))
  }),
  z.object({
    ...BaseLoadFields,
    view: z.literal(spadeView.PowerPath),
    path: z.optional(z.enum(pathsByView[spadeView.PowerPath]))
  }),
  z.object({
    ...BaseLoadFields,
    view: z.literal(spadeView.Rewards),
    path: z.optional(z.enum(pathsByView[spadeView.Rewards]))
  })
]);

export type LoadSchema = z.input<typeof LoadConfig>;
export type InitSchema = z.input<typeof InitConfig>;
